import refs from '../helpers/refs'

class CBlockSocial {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.offset = 0
    this.limit = 8

    this.init()
  }

  init () {
    this.bindEvents()
    this.createNodes()
    this.fetchMore()
  }

  bindEvents () {
    this.$refs.shade.children[0].addEventListener('click', (e) => {
      e.preventDefault()
      this.fetchMore()
    })
  }

  createNodes () {
    this.blockNode = document.createElement('div')
    this.blockNode.classList.add('c-block-social__block')

    this.imageNode = document.createElement('img')
    this.imageNode.classList.add('c-block-social__image')
    this.imageNode.alt = ''
    this.imageNode.src = ''
  }

  fetchMore () {
    const images = this.getImages()
    const blocks = this.getBlocks(images)

    for (const block of blocks) {
      this.$refs.images.append(block)
    }

    this.$refs.images.classList.remove('hidden')
  }

  getImages () {
    const images = []

    // TODO: fetch images from instagram api

    images.push(
      ...Array.from(Array(this.limit)).map((v, i) => {
        return `https://source.unsplash.com/400x400/?people&random=${
          this.offset + i
        }`
      })
    )

    this.offset += this.limit

    return images
  }

  getBlocks (images = []) {
    const blocks = []

    while (images.length > 0) {
      const portion = images.splice(0, 4)

      const blockNode = this.blockNode.cloneNode()

      for (const image of portion) {
        const imageNode = this.imageNode.cloneNode()
        imageNode.src = image

        blockNode.appendChild(imageNode)
      }

      blocks.push(blockNode)
    }

    return blocks
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-block-social]')
    .forEach(el => new CBlockSocial(el))
})
